<template>
  <div class="box">
    <vue-clock-picker :disabled="disabled" clearable :placeholder="childPlaceholder" class="time-sty" cancel-text="取消" done-text="确定" v-model="valueTime" @beforeClose="beforeClose"></vue-clock-picker>
    
    
    <i class="el-icon-circle-close anniu" @click="clean" style="float: right;"></i>
  </div>
</template>

<script>
import VueClockPicker from '@pencilpix/vue2-clock-picker';
import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';
export default {
  name:"timeSelect",
  components:{
    VueClockPicker
  },
  props:{
    timePeriod:{
      type: String,
      default: ''
    },
    childPlaceholder:{
      type: String,
      default: ''
    },
    valueTime:{
      type: String,
      default: ''
    },
    dddd:{
      type: Boolean,
      default: false
    },
    disabled:{
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
        // valueTime:""
    }
  },
  methods:{
    beforeClose(){
      this.$emit('startTimeSelect',this.timePeriod, this.valueTime);
    },
    clean(){
      this.$emit('startTimeSelect',this.timePeriod);
    }
  }
}
</script>

<style scoped lang="less">
.time-sty{
    width: 100%;
    height: 100%;
}
.clock-picker_input-container{
    width: 100%;
    height: 100%;
}
/deep/.clock-picker__input{
    border: 1px solid gainsboro;
    width: 100%;
    // height: 100%;
    height: 37px;
    border-radius: 3px;
}
.box{
  position: relative;
}
.anniu{
  position: absolute;
  right: 0;
  bottom: 13px;
}

/deep/.clock-picker__input-container /deep/.clock-picker__input--has-value{
  background: #E4E7ED;
}

</style>


// WEBPACK FOOTER //
// src/components/timeSelect/index.vue